export default __webpack_public_path__ + "static/media/Web-Application-Header.2146e1ea.png";